@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

:global(html, body) {
    margin: 0;
    padding: 0;
}

.container {
    overflow-x: hidden;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        & div {
            --decimal: 0.8;
        }
    }
}
